import React from 'react'
import './styles.scss'
// https://reactjsexample.com/a-very-simple-echarts-wrapper-for-react/
import ReactEcharts from 'echarts-for-react'
import echarts from 'echarts'

const valuesForType = (bfsID, data) => {
  // console.log('valuesForType: ', data)
  const filteredData = data.filter(t => {
    return t.BfS_number === bfsID
  })
  const valuesArr = filteredData.map(projection => projection.Estimate)
  // console.log('valuesArr: ', valuesArr)
  return valuesArr
}

export class SparkLine extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      lineData: [],
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800
    }
  }

  getMinY() {
    /*
    let lowerBounds = this.props.csvData.map(d => d.lower_bound)
    let minY = Math.min(...lowerBounds)
    if (minY > 50) {
      minY = 50
    }
    */
    const estimates = this.state.lineData
    const minY = Math.min(...estimates)
    return minY
  }

  getMaxY() {
    /*
    let upperBounds = this.props.csvData.map(d => d.upper_bound)
    let maxY = Math.max(...upperBounds)
    if (maxY < 50) {
      maxY = 50
    }
    */
    const estimates = this.state.lineData
    const maxY = Math.max(...estimates)
    return maxY
  }

  getFirstValue() {
    return parseFloat(this.props.csvData[0].Estimate)
  }

  getLastValue() {
    return parseFloat(this.state.lineData[this.state.lineData.length - 1])
  }

  getFirstTime() {
    return this.props.csvData[0].Time.substring(
      0,
      this.props.csvData[0].Time.length - 3
    )
  }

  getLastTime() {
    return this.props.csvData[this.getLastIndex()].Time.substring(
      0,
      this.props.csvData[this.getLastIndex()].Time.length - 3
    )
  }

  getLastIndex() {
    return this.state.lineData.length - 1
  }

  isAllNegative() {
    return !this.state.lineData.some(v => v > 50) //any Values below 50?
  }

  // Chart Options
  // https://ecomfe.github.io/echarts-doc/public/en/option.html#title
  getOption = () => ({
    title: {
      text: '',
      subtext: ''
    },
    tooltip: {
      position: 'left',
      show: true,
      axisPointer: {
        type: 'none'
      },
      formatter: function(params, ticket, callback) {
        console.log('#### params ####', params)
        const currIndex = params[0].dataIndex
        const currResult =
          this.props.projectionLanguage === 'fr'
            ? this.props.csvData[currIndex].result_fr
            : this.props.projectionLanguage === 'it'
            ? this.props.csvData[currIndex].result_it
            : this.props.csvData[currIndex].result
        const currLabel =
          this.props.projectionLanguage === 'fr'
            ? this.props.csvData[currIndex].label_fr
            : this.props.projectionLanguage === 'it'
            ? this.props.csvData[currIndex].label_it
            : this.props.csvData[currIndex].label
        let currTime = params[0].name.substring(0, params[0].name.length - 3)
        if (this.props.projectionLanguage === 'fr') {
          currTime = currTime.replace(':', 'h')
        }
        const currCounted =
          Math.round(this.props.csvData[currIndex].Share_counted * 100) + '%'
        const title =
          '<div class="tip-title">' + currTime + '<br />' + currLabel + '</div>'
        let communitiesText =
          this.props.projectionLanguage === 'fr'
            ? ' des communes'
            : this.props.projectionLanguage === 'it'
            ? ' dei Comuni'
            : ' der Gemeinden'
        let tooltipContent = title + '<hr class="under" />'
        console.log('estimate:', parseFloat(params[0].data))
        if (parseFloat(params[0].data) > -0.00000000001) {
          let prognoseValue = parseFloat(params[0].data)
          console.log('prognoseValue:', prognoseValue)
          let prognoseClass = 'tie'
          if (prognoseValue < 50) {
            prognoseValue = 100 - prognoseValue
            prognoseClass = 'declined'
          } else if (prognoseValue > 50) {
            prognoseClass = 'approved'
          } else {
            prognoseClass = 'tie'
          }
          prognoseValue = Math.round(prognoseValue * 10) / 10
          tooltipContent += '<div class="row ' + prognoseClass + '">'
          tooltipContent +=
            '<span class="prognose-text">' + currResult + ':</span> '
          tooltipContent +=
            '<span>' +
            prognoseValue
              .toString()
              .split('.')
              .join(',') +
            '%</span></div>' +
            '<div class="tip-bottom">' +
            currCounted +
            communitiesText +
            '</div>'
        }
        // callback(console.log('scrubbed to: ', params[0].dataIndex))
        return tooltipContent
      }.bind(this),
      textStyle: {
        color: '#333'
      },
      backgroundColor: '#f3f3f3',
      trigger: 'axis'
    },
    grid: [
      {
        top: this.state.isMobile ? '20%' : '20%',
        left: 50,
        right: 50,
        bottom: 10,
        containLabel: true
      }
    ],
    xAxis: {
      show: false,
      type: 'category',
      boundaryGap: false,
      z: -2,
      data: [...new Set(this.props.csvData.map(projection => projection.Time))],
      axisLine: {
        lineStyle: {
          color: ['#666']
        }
      },
      axisLabel: {
        formatter: function(value) {
          const yearOnly = value.substring(0, 4)
          return yearOnly
        },
        textStyle: {
          color: '#333'
        }
      }
    },
    yAxis: {
      show: false,
      inverse: this.isAllNegative(), //inverte YAxis when to estimate is all negative (< 50)
      type: 'value',
      z: -2,
      axisTick: {
        show: false
      },
      min: this.getMinY(),
      max: this.getMaxY(),
      interval: 50,
      splitLine: {
        lineStyle: {
          // Dark and light colors will be used in turns
          color: ['#666']
        }
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        formatter: function(value, index) {
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
        },
        textStyle: {
          color: '#333'
        }
      }
    },
    series: [
      {
        name: 'Prognose',
        type: 'line',
        zlevel: 2,
        showSymbol: false,
        symbolSize: 3.5,
        connectNulls: true,
        color: this.props.lineColors.declined, // this has to be defined in parent component
        data: this.state.lineData,
        markPoint: {
          data: [
            {
              name: 'Startpunkt',
              coord: [0, this.getFirstValue()],
              itemStyle: {
                color: this.getFirstValue() > 50 ? '#509133' : '#c51b7d'
              },
              label: {
                /* formatter: ['{b|Smartphones**}'].join('\n'), */
                formatter: function(param) {
                  // console.log('PARAM:', param)
                  // console.log('TIME', this.getFirstTime())
                  let cleanValue = parseFloat(param.data.coord[1])
                  if (cleanValue < 50) {
                    cleanValue = 100 - cleanValue
                  }
                  cleanValue = Math.round(cleanValue * 10) / 10
                  cleanValue += '%'
                  const cleanTime =
                    this.props.projectionLanguage === 'fr'
                      ? this.getFirstTime().replace(':', 'h')
                      : this.getFirstTime()
                  return [
                    '{b|' + cleanTime + '}',
                    '{c|' +
                      cleanValue
                        .toString()
                        .split('.')
                        .join(',') +
                      '}'
                  ].join('\n')
                }.bind(this),
                rich: {
                  b: {
                    fontSize: 12,
                    lineHeight: 13,
                    color: this.getFirstValue() > 50 ? '#509133' : '#c51b7d',
                    padding: [3, 4, 5, 4],
                    backgroundColor: this.props.lineColors.Smartphones
                  },
                  c: {
                    fontSize: 12,
                    lineHeight: 13,
                    fontWeight: 'bold',
                    color: this.getFirstValue() > 50 ? '#509133' : '#c51b7d',
                    padding: [3, 4, 5, 4],
                    backgroundColor: this.props.lineColors.Smartphones
                  }
                },
                position: 'left'
              }
            },
            {
              name: 'Endpunkt',
              coord: [this.getLastIndex(), this.getLastValue()],
              itemStyle: {
                color: this.getLastValue() > 50 ? '#509133' : '#c51b7d'
              },
              label: {
                /* formatter: ['{b|Smartphones**}'].join('\n'), */
                formatter: function(param) {
                  //console.log('PARAM:', param)
                  // console.log('TIME', this.getLastTime())
                  let cleanValue = parseFloat(param.data.coord[1])
                  if (cleanValue < 50) {
                    cleanValue = 100 - cleanValue
                  }
                  cleanValue = Math.round(cleanValue * 10) / 10
                  cleanValue += '%'
                  /* const cleanTime = this.props.csvData[0].Time.substring(0,projection.Time.length - 3) */
                  const cleanTime =
                    this.props.projectionLanguage === 'fr'
                      ? this.getLastTime().replace(':', 'h')
                      : this.getLastTime()
                  return [
                    '{b|' + cleanTime + '}',
                    '{c|' +
                      cleanValue
                        .toString()
                        .split('.')
                        .join(',') +
                      '}'
                  ].join('\n')
                }.bind(this),
                rich: {
                  b: {
                    fontSize: 12,
                    lineHeight: 13,
                    color: this.getLastValue() > 50 ? '#509133' : '#c51b7d',
                    padding: [3, 4, 5, 4],
                    backgroundColor: this.props.lineColors.Smartphones
                  },
                  c: {
                    fontSize: 12,
                    lineHeight: 13,
                    fontWeight: 'bold',
                    color: this.getLastValue() > 50 ? '#509133' : '#c51b7d',
                    padding: [3, 4, 5, 4],
                    backgroundColor: this.props.lineColors.Smartphones
                  }
                },
                position: 'right'
              }
            }
          ],
          symbol: 'circle',
          symbolSize: 8
        }
      }
      /*, UPPER LOWER BOUND
      {
        name: 'L',
        type: 'line',
        zlevel: -1,
        data: this.props.csvData.map(function(item) {
          return item.lower_bound
        }),
        lineStyle: {
          normal: {
            opacity: 0
          }
        },
        stack: 'confidence-band',
        symbol: 'none'
      },
      {
        name: 'U',
        type: 'line',
        zlevel: -1,
        data: this.props.csvData.map(function(item) {
          return item.upper_bound - item.lower_bound
        }),
        lineStyle: {
          normal: {
            opacity: 0
          }
        },
        areaStyle: {
          normal: {
            color: '#d3d3d3'
          }
        },
        stack: 'confidence-band',
        symbol: 'none'
      }
      */
    ],
    visualMap: {
      show: false,
      zlevel: -1,
      dimension: 1,
      pieces: [
        {
          gt: 0,
          lte: 50,
          color: '#c51b7d'
        },
        {
          gt: 50,
          lte: 100,
          color: '#509133'
        }
      ]
    }
  })

  componentDidMount() {
    this.setState({
      lineData: valuesForType(this.props.ballotID, this.props.csvData)
    })
  }

  componentWillReceiveProps() {
    this.setState({
      lineData: valuesForType(this.props.ballotID, this.props.csvData)
    })
  }

  render() {
    // console.log('csvData: ', this.props.csvData)
    // register theme object
    // theme object format example: https://github.com/apache/incubator-echarts/blob/master/theme/dark.js
    echarts.registerTheme('ta_theme', {
      backgroundColor: 'transparent',
      textStyle: {
        fontSize: '16',
        fontFamily:
          'TamediaChart,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif',
        color: '#333'
      },
      title: {
        textStyle: {
          color: '#333',
          fontSize: '22'
        },
        subtextStyle: {
          color: '#5f5f5f',
          fontSize: '18'
        }
      },
      legend: {
        left: 'left',
        orient: 'vertical',
        itemGap: 7,
        padding: [0, 0, 0, 10],
        itemWidth: 10,
        textStyle: {
          fontSize: '16'
        },
        show: false
      },
      label: {
        show: false
      },
      smooth: true
    })

    return (
      <div className='sparkline'>
        <ReactEcharts
          option={this.getOption()}
          opts={{ renderer: 'canvas' }}
          notMerge
          lazyUpdate
          theme='ta_theme'
          style={{ height: this.state.isMobile ? '4em' : '7em' }}
        />
      </div>
    )
  }
}

export default SparkLine
